import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoMetadata } from './seoConfig';

function ensureMeta(selector, create) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = create();
    document.head.appendChild(node);
  }
  return node;
}

function setMeta(name, content) {
  const node = ensureMeta(`meta[name="${name}"]`, () => {
    const item = document.createElement('meta');
    item.setAttribute('name', name);
    return item;
  });
  node.setAttribute('content', content);
}

function setProperty(property, content) {
  const node = ensureMeta(`meta[property="${property}"]`, () => {
    const item = document.createElement('meta');
    item.setAttribute('property', property);
    return item;
  });
  node.setAttribute('content', content);
}

function setCanonical(href) {
  const node = ensureMeta('link[rel="canonical"]', () => {
    const item = document.createElement('link');
    item.setAttribute('rel', 'canonical');
    return item;
  });
  node.setAttribute('href', href);
}

export default function SeoManager({ language }) {
  const location = useLocation();

  useEffect(() => {
    const metadata = getSeoMetadata({
      pathname: location.pathname,
      language,
    });

    document.title = metadata.title;
    setMeta('description', metadata.description);
    setMeta('robots', metadata.robots);
    setCanonical(metadata.canonical);
    setProperty('og:title', metadata.title);
    setProperty('og:description', metadata.description);
    setProperty('og:type', metadata.ogType);
    setProperty('og:url', metadata.canonical);
    setProperty('og:site_name', metadata.siteName);
    setProperty('og:locale', metadata.locale);
    setMeta('twitter:card', 'summary');
    setMeta('twitter:title', metadata.title);
    setMeta('twitter:description', metadata.description);
  }, [language, location.pathname]);

  return null;
}
